import { SellerMassImport as SellerMassImportComponent } from 'components/sellers/SellerMassImport/SellerMassImport'
import { useParams } from 'react-router-dom'

export const SellerMassImport: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return (
    <SellerMassImportComponent
      sellerId={id as string}
      useAdminStockConfirmation
    />
  )
}
